export enum EEventQueueEvents {
  OpenNewChat = 'frontend-chats-reporting.v1.open',
}
